import { useEffect, useState } from "react";
import { Button, Form, Input, notification, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { CustomerData } from "../../../Modal/Labels";
import {
  getCustomerData,
  UpdateCustomerInfo,
} from "../../../store/common/commonAsyncAction";
import Loader from "../../Loader";

interface Props {
  title?: string;
  data?: any;
}

const BasicInfo = (props: Props) => {
  const customerData = useSelector((state: any) => state.common.customerData);
  const loginResp = useSelector((state: any) => state.user.userSession);
  const Loading = useSelector((state: any) => state.common.loading);
  const [Title, setTitle] = useState("");
  const [foreName, setForeName] = useState("");
  const [surName, setSurName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [email, setEmail] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [formData, setFormData] = useState({} as CustomerData);
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props?.data) {
      setTitle(props?.data?.title);
      setSurName(props?.data?.surName);
      setBusinessName(props?.data?.businessName);
      setCustomerId(props?.data?.id);
      setEmail(props?.data?.email);
    }
  }, [props?.data]);

  const handleSave = async (formdata: any) => {
    var params = {...customerData};

    setloading(true);
    params.foreName = formdata.foreName;
    params.title = formdata.title;
    params.surName = formdata.surName;
    params.businessName = formdata.businessName;
    try {
      if(params.foreName === customerData.foreName && params.title === customerData.title &&  params.surName === customerData.surName && params.businessName === customerData.businessName){
        notification.open({
          message: "",
          description: "Profile  Updated Successfully",
          placement:"bottomRight"
        });
        setloading(false);
        return;
      }
      await dispatch(UpdateCustomerInfo(params));
      const query = `?customerId=${loginResp.userId}&customerEmail=${loginResp.email}`;

      await dispatch(getCustomerData(query));
      notification.open({
        message: "",
        description: "Profile  Updated Successfully",
        placement:"bottomRight"
      });
      //   className: "custom-class",
      //   style: {
      //     width: 400,
      //     marginTop: "40px",
      //   },
      // });
      setloading(false);
    } catch (error) {
      setloading(false);
    }
  };

  const onFinishFailed = () => {};

  return (
    <div className="user-profile">
      <Typography.Title className="setting-tab-heading" level={4}>
        {props?.title}{" "}
      </Typography.Title>
      {Loading ? (
        <Loader />
      ) : (
        <Form
          name="basic"
          layout="vertical"
          initialValues={{
            title: customerData?.title,
            foreName: customerData?.foreName,
            surName: customerData?.surName,
            businessName: customerData?.businessName,
            email: customerData?.email,
          }}
          onFinish={handleSave}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Title"
            name="title"
            rules={[
              {
                required: true,
                message: "Please input your title!",
              },
            ]}
          >
            <Input placeholder="Miss" />
          </Form.Item>
          <Form.Item
            label="Forename"
            name="foreName"
            rules={[
              {
                required: true,
                message: "Please input your Forename!",
              },
            ]}
          >
            <Input placeholder="Rose" />
          </Form.Item>
          <Form.Item
            label="Surname"
            name="surName"
            rules={[
              {
                required: true,
                message: "Please input your Surname!",
              },
            ]}
          >
            <Input placeholder="Nic" />
          </Form.Item>
          <Form.Item
            label="Business Name"
            name="businessName"
            rules={[
              {
                required: true,
                message: "Please input your Business Name!",
              },
            ]}
          >
            <Input placeholder="amazon" />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input placeholder="enter email..." disabled={true} />
          </Form.Item>
          <Form.Item className="form-btn">
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};

export default BasicInfo;
